// pages/TeacherPortal/TeacherDashboard.jsx
import React, { useState } from 'react';
import { Button, Card, Typography, Breadcrumbs, Modal } from '@mui/material';
import { Link } from 'react-router-dom';
import QuizModal from '../../components/QuizModal'; // Reusable quiz component
import AssignmentUpload from '../../components/AssignmentUpload'; // Reusable assignment component
import FeedbackCard from '../../components/FeedbackCard'; // Reusable feedback component

const TeacherDashboard = () => {
  const [currentLesson, setCurrentLesson] = useState(1);
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const [isLessonBooked, setIsLessonBooked] = useState(false);

  const lessons = [
    { id: 1, title: 'Lesson 1: Introduction' },
    { id: 2, title: 'Lesson 2: Basics' },
    { id: 3, title: 'Lesson 3: Advanced' },
  ];

  const handleNextLesson = () => {
    if (currentLesson < lessons.length) {
      setCurrentLesson(currentLesson + 1);
    }
  };

  const handlePreviousLesson = () => {
    if (currentLesson > 1) {
      setCurrentLesson(currentLesson - 1);
    }
  };

  const handleJoinLesson = () => {
    alert('Joining lesson...');
  };

  return (
    <div>
      {/* Breadcrumb */}
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/teacher/dashboard">Dashboard</Link>
        <Typography color="textPrimary">{lessons[currentLesson - 1].title}</Typography>
      </Breadcrumbs>

      {/* Next/Previous Buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px 0' }}>
        <Button variant="contained" onClick={handlePreviousLesson} disabled={currentLesson === 1}>
          Previous
        </Button>
        <Button variant="contained" onClick={handleNextLesson} disabled={currentLesson === lessons.length}>
          Next
        </Button>
      </div>

      {/* Join Lesson Card */}
      <Card style={{ padding: '20px', margin: '10px 0' }}>
        <Typography variant="h6">Join Lesson</Typography>
        <Button variant="contained" onClick={handleJoinLesson}>
          Join Lesson
        </Button>
      </Card>

      {/* Material/Reference Card */}
      <Card style={{ padding: '20px', margin: '10px 0' }}>
        <Typography variant="h6">Material/Reference</Typography>
        <Typography>Download course materials here.</Typography>
      </Card>

      {/* Quiz Card */}
      <Card style={{ padding: '20px', margin: '10px 0' }}>
        <Typography variant="h6">Quiz</Typography>
        <Button variant="contained" onClick={() => setIsQuizOpen(true)}>
          Grade Quiz
        </Button>
        <QuizModal open={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
      </Card>

      {/* Assignment Card */}
      <Card style={{ padding: '20px', margin: '10px 0' }}>
        <Typography variant="h6">Assignment</Typography>
        <AssignmentUpload />
      </Card>

      {/* Feedback Card */}
      <Card style={{ padding: '20px', margin: '10px 0' }}>
        <Typography variant="h6">Feedback</Typography>
        <FeedbackCard />
      </Card>
    </div>
  );
};

export default TeacherDashboard;